import React from 'react';
import { CoverSlot } from './CoverSlot';
import { collectionImage, productName, tomes, tools } from '../data/content';
type CollectionMockupProps = {
  /** 'photo' usa el mockup principal (collectionImage); 'covers' arma la colección con las 11 portadas reales. */
  variant?: 'photo' | 'covers';
  stage?: 'ivory' | 'deep';
};
const tomeRow = [{
  rotate: -5,
  y: 10,
  z: 1
}, {
  rotate: 0,
  y: 0,
  z: 3
}, {
  rotate: 5,
  y: 10,
  z: 2
}];
const bonusFan = [{
  rotate: -7,
  y: 14,
  z: 1
}, {
  rotate: -3.5,
  y: 4,
  z: 2
}, {
  rotate: 0,
  y: 0,
  z: 5
}, {
  rotate: 3.5,
  y: 4,
  z: 3
}, {
  rotate: 7,
  y: 14,
  z: 1
}];
export function CollectionMockup({
  variant = 'photo',
  stage = 'ivory'
}: CollectionMockupProps) {
  const stageBg = stage === 'ivory' ? 'bg-ivory' : 'bg-ivory-deep';
  const label = `Colección ${productName}: 6 tomos y 5 bonos prácticos`;
  if (variant === 'photo' && collectionImage) {
    return <img src={collectionImage} alt={label} className="mx-auto block h-auto w-full max-w-xl bg-transparent object-contain" data-id="element-17" data-mp="2ecawwd7ojzye" />;
  }
  const rows = [tomes.slice(0, 3), tomes.slice(3, 6)];
  return <div role="group" aria-label={label} className={`overflow-hidden rounded-3xl ${stageBg} px-4 pb-8 pt-7 sm:px-10 sm:pb-12 sm:pt-10`} data-id="element-18" data-mp="3qgbm2hw9v6im">
      <p className="font-sans text-[0.68rem] font-bold uppercase tracking-[0.18em] text-sage-deep" data-id="element-19" data-mp="3c56uybgxy3d">6 tomos</p>
      <div className="mt-4 space-y-5 sm:space-y-7" data-id="element-20" data-mp="3br71iu208q7c">
        {rows.map((row, rowIndex) => <div key={rowIndex} className="flex items-start justify-center" data-id="element-21" data-mp="37qdbnv5051bt" data-mpi={rowIndex}>
            {row.map((tome, index) => <div key={tome.number} className="-mx-[1.5%] w-[35%] sm:w-[30%]" style={{
          transform: `translateY(${tomeRow[index].y}px) rotate(${tomeRow[index].rotate}deg)`,
          zIndex: tomeRow[index].z
        }} data-id="element-22" data-mp="3lhrw86ek5akz" data-mpi={index}>
                <CoverSlot kicker={tome.number} title={tome.title} image={tome.image} size="sm" data-id="element-23" data-mp="2o1crslczfhrb" />
              </div>)}
          </div>)}
      </div>

      <div className="mx-auto mt-9 flex max-w-xs items-center gap-3" aria-hidden="true" data-id="element-24" data-mp="wxj6lksm4okm">
        <span className="h-px flex-1 bg-stone" data-id="element-25" data-mp="11p1c8m5kzdbx" />
        <span className="font-display text-2xl font-semibold text-terra-deep" data-id="element-26" data-mp="11pb0o5az9cfi">+</span>
        <span className="h-px flex-1 bg-stone" data-id="element-27" data-mp="16mko5fet3e0p" />
      </div>

      <p className="mt-4 font-sans text-[0.68rem] font-bold uppercase tracking-[0.18em] text-sage-deep" data-id="element-28" data-mp="90dkc7qbtppe">5 bonos</p>
      <div className="mt-4 flex items-start justify-center pb-3" data-id="element-29" data-mp="dyf1uo83tgyr">
        {tools.map((tool, index) => <div key={tool.label} className="-mx-[2%] w-[24%] sm:w-[21%]" style={{
        transform: `translateY(${bonusFan[index].y}px) rotate(${bonusFan[index].rotate}deg)`,
        zIndex: bonusFan[index].z
      }} data-id="element-30" data-mp="iy1nnm2005j6" data-mpi={index}>
            <CoverSlot kicker={tool.label} title={tool.title} image={tool.image} size="xs" data-id="element-31" data-mp="1yeim7dbljljf" />
          </div>)}
      </div>
    </div>;
}